import script from "./logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./logo.vue?vue&type=script&setup=true&lang=ts"

import "./logo.vue?vue&type=style&index=0&id=1b6514ef&lang=scss&scoped=true"

import exportComponent from "/Users/xujin/software/code/grail/grail-codegen-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6514ef"]])

export default __exports__